import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ExternalLink} from "@ispm/dashboard/external-links/interfaces/external-link";
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import {INavigationApplicationInterface} from "@ispm/navigation/interfaces";

@Component({
  selector: 'gen-external-links',
  templateUrl: './external-links.component.html',
  styleUrls: ['./external-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ExternalLinksComponent implements OnInit {
  public links: ExternalLink[] = [];
  public isAvailable: boolean = false;

  constructor(public userActionCreatorService: UserActionCreatorService,) {
  }

  ngOnInit(): void {
    let currApp = this.getCurrentAppFromSessionStorage();
    if (currApp) {
      this.userActionCreatorService.getStoredOrganizationConfiguration()
        .take(1)
        .map((orgConfig) => {
            if (orgConfig?.externalLinks) {
              let externalLinks = orgConfig.externalLinks.find(item => item.application === currApp.id);
              if (externalLinks) {
                this.isAvailable = true;
                externalLinks.links.map((link) => {
                  this.links.push(link);
                })
              }
            }
          }
        ).toPromise();
    }
  }

  public openLink(val) {
    if (val) {
      let link: ExternalLink = this.links.find(link => link.linkTitle == val);
      window.open(link?.url, '_blank');
    }
  }

  private getCurrentAppFromSessionStorage(): INavigationApplicationInterface {
    let currApp = sessionStorage.getItem('currentApplication');
    return currApp ? JSON.parse(currApp) : undefined;
  }
}
